<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: getMetaAttr('navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-east-block>
      <nuttrema-layout-west-three-vertical>
        <div slot="top-center" class="top--center__title">
          <span>{{ $t('label.add_schedule') }}</span>
        </div>
        <template slot="center">
          <ul class="east-block-search-items">
            <li v-for="group in groups">
              <nav class="level level--group">
                <div class="level-left">
                  <div class="level-item">
                    <span class="item-group-title">{{ $t('label.' + group.name) }}</span>
                  </div>
                </div>
              </nav>
              <a
                v-for="item in group.items"
                class="level level--search-item"
                @click="goto(item)">
                <div class="level-left">
                  <div class="level-item level-item--icon">
                    <nuttrema-iconica-sidebar-link
                      :icon="item.icon"
                      :theme="item.theme">
                    </nuttrema-iconica-sidebar-link>
                  </div>
                  <div class="level-item level-item--text">
                    <div class="search-item">
                      <p class="search-item-title search-item-title--normal">{{ $t('label.' + item.title) }}</p>
                      <p class="search-item-description"></p>
                    </div>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </template>
      </nuttrema-layout-west-three-vertical>
    </nuttrema-layout-east-block>

    <router-view></router-view>

  </nuttrema-layout-west-slide>
</template>

<script>
import { STUFF_TO_EAT_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'page-options-add-schedule-to-diet',
  mixins: [
    PageProps,
  ],
  components: {
    WestSlideLeftNavigation,
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  data() {
    return {
      groups: [
        {
          name: 'stuff_to_eat',
          items: [
            {
              title: 'food_product',
              icon: 'fi-bakery flaticon-023-croissant',
              theme: 'food-product',
              type: STUFF_TO_EAT_KEYS.food_product,
              itemClickNavigation: 'diet-schedule-add-stuff-to-eat-simple',
            },
            {
              title: 'dish',
              theme: 'dish',
              icon: 'fi-bakery flaticon-018-pie',
              type: STUFF_TO_EAT_KEYS.dish,
              itemClickNavigation: 'diet-schedule-add-stuff-to-eat-simple',
            },
            {
              title: 'drink',
              theme: 'drink',
              type: STUFF_TO_EAT_KEYS.drink,
              icon: 'fi-coffee-shop flaticon-024-cocktail',
              itemClickNavigation: 'diet-schedule-add-stuff-to-eat-simple',
            },
            {
              title: 'meal',
              theme: 'meal',
              icon: 'fi-meal flaticon-008-chicken-1',
              type: STUFF_TO_EAT_KEYS.meal,
              itemClickNavigation: 'diet-schedule-add-stuff-to-eat-complex',
            },
          ],
        },
        // {
        //   name: 'workouts',
        //   items: [
        //     {
        //       title: 'basic_activity',
        //       icon: 'icon-ca-running',
        //       color: 'workouts',
        //     },
        //     {
        //       title: 'excersize',
        //       icon: 'icon-ca-skipping',
        //       color: 'workouts',
        //     },
        //     {
        //       title: 'training',
        //       icon: 'icon-ca-stopwatch',
        //       color: 'workouts',
        //     },
        //   ],
        // },
        // {
        //   name: 'things_to_do',
        //   items: [
        //     {
        //       title: 'fill_survey',
        //       icon: 'icon-ca-checked',
        //       color: 'things-to-do',
        //     },
        //     {
        //       title: 'reminder',
        //       icon: 'icon-ca-bell',
        //       color: 'things-to-do',
        //     },
        //     {
        //       title: 'add_measurement',
        //       icon: 'icon-ca-ruler',
        //       color: 'things-to-do',
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    goto(item) {
      console.log('clicked on route', item);
      this.$router.push({
        name: this.meta.navigation.search,
        params: {
          entityType: item.type,
          itemParamName: 'entityID',
          itemClickNavigation: item.itemClickNavigation,
        },
      });
    },
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/cred/page-options-add-schedule-to-diet.vue